export const PENDING_ENTITY_PROCESSOR_ROUTE = "pendingEntityProcessorRoute";

const isSupportedPostLoginRoute = (route) => {
  if (typeof route !== "string" || !route.startsWith("/") || route.startsWith("//")) {
    return false;
  }

  // Avoid redirecting back into authentication flows after a successful login.
  return !route.startsWith("/authentication/");
};

export const savePendingEntityProcessorRoute = (route) => {
  if (isSupportedPostLoginRoute(route)) {
    localStorage.setItem(PENDING_ENTITY_PROCESSOR_ROUTE, route);
    try {
      sessionStorage.setItem("pendingPostLoginScrollY", String(window.scrollY || 0));
    } catch {
      // Route restoration still works when scroll storage is unavailable.
    }
  }
};

export const takePostLoginDestination = (fallbackRoute) => {
  const route = localStorage.getItem(PENDING_ENTITY_PROCESSOR_ROUTE);
  localStorage.removeItem(PENDING_ENTITY_PROCESSOR_ROUTE);

  return isSupportedPostLoginRoute(route) ? route : fallbackRoute;
};
